import FinanceSerializer from './base';
import { isEmpty } from '@ember/utils';

export default class LineItem extends FinanceSerializer {
  normalize(modelClass, payload) {
    let amount = payload.amount || 0;
    let displayAmount = payload.displayAmount || 0;
    let balance = payload.balance || 0;
    payload.amount = (amount / 100).toFixed(2);
    payload.displayAmount = (displayAmount / 100).toFixed(2);
    payload.balance = (balance / 100).toFixed(2);
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    hash.ledgerId = parseInt(hash.ledgerId, 10);
    hash.ledgerItemId = parseInt(hash.ledgerItemId, 10);
    if (!isEmpty(hash.costCentreId)) {
      hash.costCentreId = parseInt(hash.costCentreId, 10);
    }
    if (!isEmpty(hash.internalOrderId)) {
      hash.internalOrderId = parseInt(hash.internalOrderId, 10);
    }
    hash.accountId = parseInt(hash.accountId, 10);
    hash.amount = Math.round(hash.amount * 100);
    hash.displayAmount = Math.round(hash.displayAmount * 100);
    hash.balance = Math.round(hash.balance * 100);
    return hash;
  }
}
